import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import { API_LISTAR_CONVERSOES_ENERGIA } from 'store/modules/api/conversoesEnergia.actions'

const lista = (state = [], { type, payload }) => (
  (type === API_LISTAR_CONVERSOES_ENERGIA.success) ? payload : state
)

const isCarregandoLista = loadingReducer(false, API_LISTAR_CONVERSOES_ENERGIA)

export default combineReducers({
  lista,
  isCarregandoLista,
})
